module.exports = __webpack_public_path__ + "static/media/po.6f2cb741.png";